import { FontWeight, Heading, Text } from '@lili/lili-frontend-common';
import { Trans, useTranslation } from 'react-i18next';
import { PhoneInput } from '@Components/inputs/Phone';
import { OnboardingFormFields } from '@Types/index.ts';
import { DateOfBirthInput } from '@Components/inputs/DateOfBirthInput';
import { CurrentDate } from '@Components/CurrentDate/CurrentDate';
import { ReactNode } from '@tanstack/react-router';

export type AdminPersonalDetailsFormType = {
  [OnboardingFormFields.PHONE_NUMBER]: string;
  [OnboardingFormFields.DATE_OF_BIRTH]: string;
};

// this is due to a workaround for the i18n issue https://github.com/i18next/react-i18next/issues/1747
const LinkToAgreement = ({ children, href }: { children?: ReactNode; href: string }) => {
  return (
    <a
      href={href}
      target='_blank'
      rel='noreferrer'
      className='underline text-text-brand-primary hover:text-text-brand-primary-hover'>
      {children}
    </a>
  );
};

export const AdminPersonalDetailsForm = () => {
  const { t } = useTranslation('inviteTeamMember');

  return (
    <div className='flex flex-col w-full mt-[24px]'>
      <PhoneInput />
      <DateOfBirthInput />
      <div>
        <CurrentDate label={t('accountantPersonalDetails.currentDate')} className='mb-[24px]' />

        <div className='bg-surface-primary-bw-01 rounded-[12px] p-[16px] outline outline-1 outline-outline-primary-bw-03'>
          <Heading.H9 fontWeight={FontWeight.MEDIUM} className='mb-[4px]'>
            {t('adminPersonalDetails.authorizationTitle')}
          </Heading.H9>
          <Text.H10 className='text-text-main-secondary whitespace-pre-line'>
            <Trans
              t={t}
              i18nKey='adminPersonalDetails.authorizationText'
              components={{
                CustomLink: (
                  <LinkToAgreement href='https://lili.co/legal-documents/sunrise-account-agreement' />
                ),
              }}
            />
          </Text.H10>
        </div>
      </div>
    </div>
  );
};
